import React, { useState } from 'react'

import './Projects.scss'

export default function Coinfundr() {
	const [webHover, setWebHover] = useState(false)
	const [figmaHover, setFigmaHover] = useState(false)

	const figmaImg = !figmaHover ? (
		<svg viewBox='0 0 72 108' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M19.125 0C8.58942 0 0 8.77217 0 19.5319C0 27.1156 4.38734 33.5325 10.5952 36.766C4.38734 39.9994 0 46.4163 0 54C0 61.5836 4.38734 68.0006 10.5952 71.234C4.38734 74.4675 0 80.8844 0 88.4681C0 99.2278 8.58942 108 19.125 108C29.6606 108 38.25 99.2278 38.25 88.4681V71.234V63.5505C41.2681 69.3997 47.0971 73.5319 54 73.5319C63.9145 73.5319 72 65.2744 72 55.1489C72 46.8266 66.4339 40.0489 58.9834 37.7982C66.4955 35.1614 72 28.0805 72 19.5319C72 8.77217 63.4106 0 52.875 0H36H19.125ZM19.125 4.59574H33.75V34.4681H19.125C11.0216 34.4681 4.5 27.8077 4.5 19.5319C4.5 11.2561 11.0216 4.59574 19.125 4.59574ZM38.25 4.59574H52.875C60.9784 4.59574 67.5 11.2561 67.5 19.5319C67.5 27.8077 60.9784 34.4681 52.875 34.4681H38.25V4.59574ZM19.125 39.0638H33.75V68.9362H19.125C11.0216 68.9362 4.5 62.2758 4.5 54C4.5 45.7242 11.0216 39.0638 19.125 39.0638ZM38.25 39.0638H45.7734C42.5449 40.8014 39.9513 43.4501 38.25 46.7473V39.0638ZM54 41.3617C61.4825 41.3617 67.5 47.5072 67.5 55.1489C67.5 62.7906 61.4825 68.9362 54 68.9362C46.5175 68.9362 40.5 62.7906 40.5 55.1489C40.5 47.5072 46.5175 41.3617 54 41.3617ZM19.125 73.5319H33.75V88.4681C33.75 96.7439 27.2284 103.404 19.125 103.404C11.0216 103.404 4.5 96.7439 4.5 88.4681C4.5 80.1923 11.0216 73.5319 19.125 73.5319Z'
				fill='rgb(244, 239, 236)'
			/>
		</svg>
	) : (
		<svg viewBox='0 0 72 108' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M38.5714 36H18C8.05886 36 0 27.9411 0 18C0 8.05886 8.05886 0 18 0H38.5714V36Z'
				fill='#E64A19'
			/>
			<path
				d='M36 72H18C8.05886 72 0 63.9411 0 54C0 44.0589 8.05886 36 18 36H36V72Z'
				fill='#7C4DFF'
			/>
			<path
				d='M18 108C8.05886 108 0 99.9411 0 90C0 80.0589 8.05886 72 18 72H36V90C36 99.9411 27.9411 108 18 108Z'
				fill='#66BB6A'
			/>
			<path
				d='M54 36H36V0H54C63.9411 0 72 8.05886 72 18C72 27.9411 63.9411 36 54 36Z'
				fill='#FF7043'
			/>
			<path
				d='M54 72C63.9411 72 72 63.9411 72 54C72 44.0589 63.9411 36 54 36C44.0589 36 36 44.0589 36 54C36 63.9411 44.0589 72 54 72Z'
				fill='#29B6F6'
			/>
		</svg>
	)

	const webImg = !webHover ? (
		<svg viewBox='0 0 72 72' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M36 72C51.5257 72 64.768 62.1508 69.816 48.3665C69.8235 48.3464 69.8311 48.3262 69.8381 48.3056C71.2366 44.4656 72 40.3209 72 35.9998C72 16.1306 55.8693 0 36 0C16.1307 0 0 16.1306 0 35.9998C0 39.9757 0.646029 43.8015 1.83831 47.3788C1.83579 47.4246 1.83428 47.4715 1.83428 47.5179C1.83428 48.1498 2.08019 48.7253 2.48232 49.1526C7.74081 62.5251 20.7726 71.9992 36.0003 71.9992L36 72ZM45.4052 49.9055C44.5279 54.7231 43.2031 58.8808 41.5542 62.0107C40.6396 63.7462 39.6403 65.1431 38.5427 66.0894C37.7349 66.7859 36.8974 67.2248 35.9994 67.2248C35.1019 67.2248 34.2639 66.7864 33.456 66.0894C32.3585 65.1431 31.3592 63.7462 30.4446 62.0107C28.7958 58.8808 27.4709 54.7236 26.5935 49.9055H45.4052ZM21.76 49.9055H8.03906C11.883 57.6145 18.8236 63.5141 27.2285 65.9742C26.8808 65.4305 26.5442 64.851 26.2206 64.2367C24.2946 60.5812 22.7375 55.6418 21.7599 49.9057L21.76 49.9055ZM63.9599 49.9055H50.239C49.2614 55.6412 47.7043 60.5806 45.7783 64.2366C45.4543 64.8513 45.1177 65.4309 44.7705 65.9741C53.1754 63.515 60.1155 57.6145 63.9599 49.9054L63.9599 49.9055ZM20.9073 28.9579H5.5725C5.04992 31.2216 4.77378 33.5788 4.77378 36.0002C4.77378 39.1764 5.24898 42.2423 6.13232 45.1307H21.102C20.7921 42.2196 20.6263 39.1588 20.6263 36.0002C20.6263 33.588 20.7231 31.2332 20.907 28.9579H20.9073ZM46.3057 28.9579C46.4967 31.2261 46.5969 33.5825 46.5969 36.0002C46.5969 39.1704 46.4246 42.2347 46.1011 45.1307H25.8977C25.5742 42.2347 25.4018 39.1699 25.4018 36.0002C25.4018 33.5825 25.5021 31.2261 25.6931 28.9579H46.3057ZM66.4252 28.9579H51.0904C51.2739 31.2326 51.3711 33.588 51.3711 36.0002C51.3711 39.1588 51.2053 42.2196 50.8954 45.1307H65.8651C66.7485 42.2422 67.2237 39.1759 67.2237 36.0002C67.2237 33.5788 66.9475 31.2216 66.425 28.9579H66.4252ZM27.2285 6.02623C18.0808 8.70306 10.6669 15.4567 7.09217 24.1835H21.4349C22.3707 17.557 24.0649 11.856 26.2207 7.76391C26.5447 7.14913 26.8813 6.56962 27.2285 6.02636L27.2285 6.02623ZM35.9992 4.7755C36.8967 4.7755 37.7347 5.21391 38.5426 5.91084C39.6401 6.8572 40.6394 8.25406 41.554 9.98955C43.4367 13.5623 44.8971 18.4755 45.7512 24.1825H26.2483C27.1025 18.4752 28.5628 13.5619 30.4455 9.98955C31.3601 8.25406 32.3594 6.85721 33.4569 5.91084C34.2647 5.21443 35.1023 4.7755 36.0003 4.7755H35.9992ZM44.77 6.02623C45.1177 6.56996 45.4543 7.14947 45.7779 7.76378C47.9336 11.8557 49.6273 17.5565 50.5637 24.1834H64.9064C61.3315 15.4569 53.9183 8.70293 44.7701 6.0261L44.77 6.02623Z'
				fill='rgb(244, 239, 236)'
			/>
		</svg>
	) : (
		<svg viewBox='0 0 72 72' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M36 72C51.5257 72 64.768 62.1508 69.816 48.3665C69.8235 48.3464 69.8311 48.3262 69.8381 48.3056C71.2366 44.4656 72 40.3209 72 35.9998C72 16.1306 55.8693 0 36 0C16.1307 0 0 16.1306 0 35.9998C0 39.9757 0.646029 43.8015 1.83831 47.3788C1.83579 47.4246 1.83428 47.4715 1.83428 47.5179C1.83428 48.1498 2.08019 48.7253 2.48232 49.1526C7.74081 62.5251 20.7726 71.9992 36.0003 71.9992L36 72ZM45.4052 49.9055C44.5279 54.7231 43.2031 58.8808 41.5542 62.0107C40.6396 63.7462 39.6403 65.1431 38.5427 66.0894C37.7349 66.7859 36.8974 67.2248 35.9994 67.2248C35.1019 67.2248 34.2639 66.7864 33.456 66.0894C32.3585 65.1431 31.3592 63.7462 30.4446 62.0107C28.7958 58.8808 27.4709 54.7236 26.5935 49.9055H45.4052ZM21.76 49.9055H8.03906C11.883 57.6145 18.8236 63.5141 27.2285 65.9742C26.8808 65.4305 26.5442 64.851 26.2206 64.2367C24.2946 60.5812 22.7375 55.6418 21.7599 49.9057L21.76 49.9055ZM63.9599 49.9055H50.239C49.2614 55.6412 47.7043 60.5806 45.7783 64.2366C45.4543 64.8513 45.1177 65.4309 44.7705 65.9741C53.1754 63.515 60.1155 57.6145 63.9599 49.9054L63.9599 49.9055ZM20.9073 28.9579H5.5725C5.04992 31.2216 4.77378 33.5788 4.77378 36.0002C4.77378 39.1764 5.24898 42.2423 6.13232 45.1307H21.102C20.7921 42.2196 20.6263 39.1588 20.6263 36.0002C20.6263 33.588 20.7231 31.2332 20.907 28.9579H20.9073ZM46.3057 28.9579C46.4967 31.2261 46.5969 33.5825 46.5969 36.0002C46.5969 39.1704 46.4246 42.2347 46.1011 45.1307H25.8977C25.5742 42.2347 25.4018 39.1699 25.4018 36.0002C25.4018 33.5825 25.5021 31.2261 25.6931 28.9579H46.3057ZM66.4252 28.9579H51.0904C51.2739 31.2326 51.3711 33.588 51.3711 36.0002C51.3711 39.1588 51.2053 42.2196 50.8954 45.1307H65.8651C66.7485 42.2422 67.2237 39.1759 67.2237 36.0002C67.2237 33.5788 66.9475 31.2216 66.425 28.9579H66.4252ZM27.2285 6.02623C18.0808 8.70306 10.6669 15.4567 7.09217 24.1835H21.4349C22.3707 17.557 24.0649 11.856 26.2207 7.76391C26.5447 7.14913 26.8813 6.56962 27.2285 6.02636L27.2285 6.02623ZM35.9992 4.7755C36.8967 4.7755 37.7347 5.21391 38.5426 5.91084C39.6401 6.8572 40.6394 8.25406 41.554 9.98955C43.4367 13.5623 44.8971 18.4755 45.7512 24.1825H26.2483C27.1025 18.4752 28.5628 13.5619 30.4455 9.98955C31.3601 8.25406 32.3594 6.85721 33.4569 5.91084C34.2647 5.21443 35.1023 4.7755 36.0003 4.7755H35.9992ZM44.77 6.02623C45.1177 6.56996 45.4543 7.14947 45.7779 7.76378C47.9336 11.8557 49.6273 17.5565 50.5637 24.1834H64.9064C61.3315 15.4569 53.9183 8.70293 44.7701 6.0261L44.77 6.02623Z'
				fill='#29B6F6'
			/>
		</svg>
	)

	function mouseEnter(id) {
		if (id === 1) {
			setWebHover(true)
		} else if (id === 2) {
			setFigmaHover(true)
		}
	}

	function mouseLeave(id) {
		if (id === 1) {
			setWebHover(false)
		} else if (id === 2) {
			setFigmaHover(false)
		}
	}

	return (
		<>
			<section className='grid project__page-title'>
				<div className='content'>
					<h2>Ilimi – AI-Powered Course and Quiz Generation</h2>
				</div>
			</section>

			<div className='grid project__page'>
				<section className='content project__page-desc'>
					<div className='project__page-text'>
						<div className='project__page-tools'>
							<p>
								TOOLS: <span>TYPESCRIPT</span> <span>NEXT JS</span>{' '}
								<span>TAILWIND CSS</span> <span>OPENAI</span>{' '}
							</p>
						</div>

						<h4 className='project__page-heading-primary'>Overview:</h4>
						<p>
							Ilimi is an AI-driven platform that empowers individuals and
							educators, to effortlessly create high-quality learning content
							including structured courses, dynamic quizzes, and personalized
							learning pathways with the help of artificial intelligence.
							<br />
							Built with a focus on accessibility, speed, and educational depth,
							Ilimi makes it possible to transform a topic idea into a
							fully-fledged, interactive learning experience in just minutes.
						</p>

						<h4 className='project__page-heading'>Core Features:</h4>
						<ul>
							<li>
								<span className='project__page-text-bold'>
									Course Generation{' '}
								</span>
								<span>
									Users can input a topic, and Ilimi automatically breaks it
									down into structured modules, sections, and learning
									objectives. Our AI ensures that content is logically
									sequenced, accurate, and tailored to a user’s intended
									audience whether beginner, intermediate, or advanced.
								</span>
							</li>
							<li>
								<span className='project__page-text-bold'>
									Deep Content Structuring{' '}
								</span>
								<span>
									I employed a pipeline approach to course generation: first
									mapping out the curriculum structure, then generating content
									section by section. This allows for modular development,
									detailed responses, and ensures high-quality output without
									overwhelming the AI or the user.
								</span>
							</li>
							<li>
								<span className='project__page-text-bold'>
									Quiz Generation{' '}
								</span>
								<span>
									With support for multiple-choice questions (single or multiple
									correct answers), Ilimi generates intelligent quizzes that
									match the course material in difficulty and scope. Questions
									come with explanations, making them useful for both learning
									and assessment.
								</span>
							</li>
							<li>
								<span className='project__page-text-bold'>
									Smart Visual Aids{' '}
								</span>
								<span>
									Depending on the subject matter, Ilimi automatically generates
									visualizations such as graphs, charts, diagrams, or even code
									snippets, enhancing learning through multimodal content.
								</span>
							</li>
						</ul>

						<h4 className='project__page-heading'>Why I Built Ilimi</h4>
						<p>
							The idea behind Ilimi was born from a simple challenge:
							high-quality education is hard to scale manually. Creating
							engaging, structured, and pedagogically sound content takes time,
							and not everyone has the resources to do it well. By leveraging
							AI, I wanted to give creators and educators the ability to build
							great learning materials — faster, smarter, and more intuitively.
						</p>

						<h4 className='project__page-heading'>Current Status:</h4>
						<p>-Beta version is live</p>
						<p>-Early users are testing and providing feedback</p>
						<p>
							{' '}
							-Roadmap includes AI-assisted lesson customization, multilingual
							support, and other collaboration tools for teams
						</p>

						<div className='project__page-btns'>
							<a
								href='https://www.ilimi.ai'
								onMouseEnter={() => mouseEnter(1)}
								onMouseLeave={() => mouseLeave(1)}
								rel='noreferrer'
								target='_blank'
							>
								<p>Visit Ilimi </p>
								<span>{webImg}</span>
							</a>
						</div>
					</div>
				</section>
			</div>
		</>
	)
}
